export const VERSION_RELOAD_GUARD_KEY = "insideFleet@versionReload";

export function normalizeAppVersion(version: string): string {
  if (version.toLowerCase() === "development") {
    return "development";
  }

  return version.length > 7 ? version.slice(0, 7) : version;
}

export function getClientAppVersion(
  configuredVersion = import.meta.env.VITE_APP_VERSION,
): string {
  return normalizeAppVersion(configuredVersion ?? "development");
}

export async function isAppVersionCurrent(
  clientVersion: string,
  fetchServerVersion: () => Promise<string | null>,
): Promise<boolean> {
  if (clientVersion === "development") {
    return true;
  }

  const serverVersionRaw = await fetchServerVersion();
  if (!serverVersionRaw) {
    return true;
  }

  const serverVersion = normalizeAppVersion(serverVersionRaw);

  if (serverVersion === clientVersion) {
    return true;
  }

  if (sessionStorage.getItem(VERSION_RELOAD_GUARD_KEY) === serverVersion) {
    return true;
  }

  sessionStorage.setItem(VERSION_RELOAD_GUARD_KEY, serverVersion);
  return false;
}

async function fetchServerVersionFromApi(): Promise<string | null> {
  const response = await fetch("/api/public/version");

  if (!response.ok) {
    return null;
  }

  const payload = (await response.json()) as { version?: string };
  return payload.version ?? null;
}

export async function checkAppVersion(): Promise<boolean> {
  return isAppVersionCurrent(getClientAppVersion(), fetchServerVersionFromApi);
}
